import { ReactNode } from 'react'

// UI
import { Button, Dropdown, Text } from '@/ui'

// BL
import { UserDocument } from '../lib/userDocuments.slice'
import { useFeatureDispatch, openDeleteConfirm } from '../lib/state'
import { faEllipsis } from '@fortawesome/pro-solid-svg-icons'

interface UserDocumentActionButtonProps {
  document: UserDocument
  /** Additional menu items rendered above "Delete File". */
  children?: ReactNode
}

export const UserDocumentActionButton = ({
  document,
  children,
}: UserDocumentActionButtonProps) => {
  const dispatch = useFeatureDispatch()

  const openConfirm = () => {
    dispatch?.(openDeleteConfirm(document))
  }

  return (
    <Dropdown>
      <Dropdown.Trigger asChild>
        <Button variant="discreet" size="square" iconRight={faEllipsis} />
      </Dropdown.Trigger>

      <Dropdown.Content align="end">
        {children}
        <Dropdown.Item onClick={openConfirm}>
          <Text>Delete File</Text>
        </Dropdown.Item>
      </Dropdown.Content>
    </Dropdown>
  )
}
